import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { useIntl } from 'react-intl';

import {
  MessageWrapper,
  Container,
  HeadingWrapper,
  Heading,
  Logo,
  Content,
} from './styles';

const ConflictingStoreMessage = () => {
  const intl = useIntl();
  const conflictingStoreMessage = useStaticQuery(conflictingStoreMessageQuery);
  const warningData = intl.locale === 'fr'
    ? conflictingStoreMessage?.conflictingStoreMessageFR
    : conflictingStoreMessage?.conflictingStoreMessageEN;
  return (
    <MessageWrapper>
      <Container>
        <HeadingWrapper>
          <Logo image={warningData.cardIcon} />
          <Heading>{warningData.cardHeading}</Heading>
        </HeadingWrapper>
        <Content>{warningData.cardDescription.cardDescription}</Content>
      </Container>
    </MessageWrapper>
  );
};

const conflictingStoreMessageQuery = graphql`
  query ConflictingStoreMessageQuery {
    conflictingStoreMessageEN: contentfulCardItem(
      contentful_id: { eq: "5Xqz5tmk4Emf2eFhF9MCtT" }
      node_locale: { eq: "en-CA" }
    ) {
      cardHeading
      cardIcon {
        altText
        asset {
          url
          localImage {
            id
            publicURL
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
      cardDescription {
        cardDescription
      }
    }
    conflictingStoreMessageFR: contentfulCardItem(
      contentful_id: { eq: "5Xqz5tmk4Emf2eFhF9MCtT" }
      node_locale: { eq: "fr-CA" }
    ) {
      cardHeading
      cardIcon {
        altText
        asset {
          url
          localImage {
            id
            publicURL
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
      cardDescription {
        cardDescription
      }
    }
  }
`;

export default ConflictingStoreMessage;
